import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class BaggageTripsAdminService extends BaseService<any> {
  constructor() {
    super(`baggage-trips`);
  }

  // Приём оплаты по поездке (одна квитанция). payload: { method? }
  pay = (id: any, payload: any) => appAxios.post(`${this.pathWithOrg()}/${id}/pay`, payload);

  refund = (id: any) => appAxios.post(`${this.pathWithOrg()}/${id}/refund`);

  // Выдача отправки получателю: прибывшие места переводим в «выдан».
  deliver = (id: any) => appAxios.post(`${this.pathWithOrg()}/${id}/deliver`);

  // Предварительный расчёт стоимости для мастера (ничего не сохраняет).
  // payload: { totalWeight, pieceCount, declaredValue, ticketNumber }
  quote = (payload: any) => appAxios.post(`${this.pathWithOrg()}/quote`, payload);

  // Атомарное оформление: отправка + N мест + (опц.) оплата.
  checkout = (payload: any) => appAxios.post(`${this.pathWithOrg()}/checkout`, payload);

  // Квитанция (blob) — тянем через axios, чтобы прошёл Bearer-токен.
  getReceiptPdf = (id: any) =>
    appAxios.get(`${this.pathWithOrg()}/${id}/receipt.pdf`, { responseType: "blob" });

  // Бирки всех мест отправки одним PDF (blob).
  getLabelsPdf = (id: any) =>
    appAxios.get(`${this.pathWithOrg()}/${id}/labels.pdf`, { responseType: "blob" });
}

export default new BaggageTripsAdminService();
